type PageInfo = {page:string, url:string}

type Page = {execute:Function,onParamChanged?:Function}
var
  Html5History = !!(window.history && window.history.pushState),
  pagesByNames :{[uri:string]:Page}= {},
  defaultUrl :string,
  fakeUrl :string,
  ourHistory,
  pageDefinitionLoader :(uri:string)=>Promise<any>,
  enabled = Html5History,
  currentPage :Page,
  filter :(page:PageInfo)=>boolean = (str)=>true;

export function setFilter(filterInput :(page:PageInfo)=>boolean){
  filter = filterInput
}


export function extractPage(url :string) :PageInfo{
  var
    search="",
    questionMarkIndex=url.indexOf('?');

  if(questionMarkIndex>-1){
    search = url.substring(questionMarkIndex);
    url = url.substring(0,questionMarkIndex);
  }
  var
    lastSlashIndex = url.lastIndexOf('/');
  if(lastSlashIndex>-1){
    url = url.substring(lastSlashIndex+1);
  }
  if(url.length===0){
    return {page:defaultUrl,url:defaultUrl};
  }
  return {page:url,url:(url+search)};
}

export function extractParam(url :string){
  var
    hash :namedString = {},
    params : string[];

  if(url.indexOf('?')>-1){
    params = url.substring(url.indexOf('?')+1).split('&');
    for(var i=0;i<params.length;i++){
      var [key,value] = params[i].split('=');
      if(value){
        hash[ key ] = decodeURIComponent( value );
      }
    }
  }
  return hash;
}

export function setPageDefinitionLoader(loader: (url: string)=>Promise<any>){
  pageDefinitionLoader = loader;
}
export function setDefaultUrl(url :string){
  defaultUrl = extractPage(url).page;
}
export function register(name :string, page :Page){
  if(pagesByNames[name]) throw new Error('page defined twice '+name)
  pagesByNames[name] = page;
  return page;
}
function getPageNoDefault(url :string){
  return pagesByNames[extractPage(url).page];
}
export function getPage(url :string){
  return pagesByNames[extractPage(url).page]||pagesByNames[defaultUrl];
}
export async function refresh(){
  currentPage = undefined;
  return run();
}
export function getPageName(){
  return extractPage(getLocation()).page;
}
export function getURLParams(){
  return extractParam(getLocation());
}
export function getURLParam(name:string){
  return getURLParams()[name];
}
async function run(){
  var
    location = getLocation(),
    page = getPageNoDefault(location);

  if(!page){
    await pageDefinitionLoader(location);
    page = getPage(location);
  }
  if(page===currentPage){
    page.onParamChanged();
    return;
  }
  currentPage = page;
  return page.execute();


}
export function init(){
  ourHistory = [extractPage(getLocation()).url]
  history.replaceState(null,null,getLocation());
  return run();
}
export function getLocation(){
  if(fakeUrl!==undefined) return fakeUrl;
  return window.location.pathname+window.location.search;
}
export function goTo(url :string,forgetCurrentHistory = false,clearContext = false){
  closeAllOverlays();
  if(!filter(extractPage(url))) return;

  if(document.getElementById('google_pubconsole_filler')){
    window.location.href = url;
    return;
  }

  if(!enabled){
    fakeUrl = url;
  }else{
    var
      extracted = extractPage(url),
      extractedUrl = extracted.url;

    if(forgetCurrentHistory){
      ourHistory[ourHistory.length-1] = extractedUrl;
      history.replaceState(null,null,url);
    }else{
      ourHistory.push(extractedUrl);
      history.pushState(null,null,url);
    }
  }
  if(clearContext){
    currentPage = undefined;
  }
  return run();
}
export function replaceState(url :string){
  if(!enabled){
    fakeUrl = url;
  }else{
    var
      extracted = extractPage(url).url;

    ourHistory[ourHistory.length-1] = extracted;
    history.replaceState(null,null,url);

  }
}
export function clearParamInHistory(){
  let pageWithoutParam = getPageName();
  //it should always be the case, but it happens one time to be undefined but i cannot reproduce understand.
  //so if no pageWithoutParam we do nothing
  if(pageWithoutParam){
    history.replaceState(null,null,pageWithoutParam);
  }

}
export function goBack(url :string){
  closeAllOverlays();
  if(!enabled){
    fakeUrl = url;
  }else{
    var
      extracted = extractPage(url).url,
      backIdx = ourHistory.indexOf(extracted);
    if(backIdx>-1){
      var goto = ourHistory.length-1 -backIdx;
      history.go(-goto);
      return;
    }
    ourHistory = [extracted];
    history.pushState(null,null,url);
  }
  run();
}
export function enable(){
  fakeUrl = undefined;
  enabled = Html5History;
}
export function disable(){
  enabled = false;
}

type OverlayEntry = { close: ()=>void, alive: boolean }
var overlayStack: OverlayEntry[] = [];
var skipNextPop = false;

export function pushOverlay(close: ()=>void): ()=>void {
  var entry: OverlayEntry = { close, alive: true };
  overlayStack.push(entry);
  history.pushState({overlay:true}, null);
  return function dismiss(){
    if(!entry.alive) return;
    var idx = overlayStack.indexOf(entry);
    if(idx === -1) return;
    var count = overlayStack.length - idx;
    for(var i = overlayStack.length - 1; i > idx; i--){
      overlayStack[i].alive = false;
      overlayStack[i].close();
    }
    entry.alive = false;
    overlayStack.length = idx;
    skipNextPop = true;
    history.go(-count);
  }
}

function closeAllOverlays(){
  for(var i = overlayStack.length - 1; i >= 0; i--){
    overlayStack[i].alive = false;
    overlayStack[i].close();
  }
  overlayStack.length = 0;
}

window.onpopstate = function(event) {
  if(skipNextPop){
    skipNextPop = false;
    return;
  }
  if(overlayStack.length > 0){
    var entry = overlayStack.pop();
    if(entry.alive){
      entry.alive = false;
      entry.close();
    }
    return;
  }
  if(event.state && event.state.overlay){
    history.back();
    return;
  }
  var
    extracted = extractPage(location.toString()).url;
  ourHistory.length = ourHistory.lastIndexOf(extracted)+1;
  run();
};

document.addEventListener("click",function(event){
  var
    href :string,
    a = event.target as HTMLElement;

  while(a.nodeName!=='A'){
    a = a.parentNode as HTMLElement|null
    if(!a) return;
  }
  if(!(href = a.getAttribute('href'))){
    return;
  }
  if(a.getAttribute('download')!==null){
    event.stopImmediatePropagation();
    event.stopPropagation();
    return false;
  }
  //we do not want url with #machin because it will send a hashchange event
  if(!Html5History &&  href.indexOf('#')===0){
    event.preventDefault();
    return false;
  }
  //if there is a page of this name registered we handle the link ourself
  //FIXME put this kind of match in pageDefinitionLoader
  //here it is really specific to our case
  if(href.match(/^\w*.php/)){
    event.preventDefault();

    //if(href===extractPage(window.location.href).url) return;

    goTo(href);
    return false;
  }
  //an unknown url we go to see it
  return true;
});